"use strict";

/**
 * dialog.showModal() 後の先頭スクロールを抑止（フォーカス・body 固定などの副作用対策）
 *
 * setTimeout(0): 開くボタンのクリックが同一ジェスチャーで dialog（backdrop）側に届き、
 * 表示直後に閉じてしまうブラウザ挙動を避ける。
 * 他 dialog の close: showModal は同時に1つのモーダルのみの環境があるため、競合を解消する。
 *
 * 位置は CSS でビューポート中央固定（CTA 座標には依存しない）。
 */
globalThis.showModalKeepScroll = function showModalKeepScroll(dialog) {
  if (!dialog || typeof dialog.showModal !== "function") {
    return;
  }

  const y = window.scrollY;

  window.setTimeout(() => {
    const restoreScroll = () => {
      requestAnimationFrame(() => {
        window.scrollTo(0, y);
        requestAnimationFrame(() => {
          window.scrollTo(0, y);
        });
      });
    };

    if (dialog.open) {
      dialog.classList.add("js-show");
      restoreScroll();
      return;
    }

    document.querySelectorAll("dialog[open]").forEach((other) => {
      if (other !== dialog) {
        other.classList.remove("js-show");
        other.close();
      }
    });

    try {
      dialog.showModal();
    } catch (e) {
      if (typeof console !== "undefined" && console.error) {
        console.error("showModal に失敗しました:", e);
      }
      return;
    }

    dialog.classList.add("js-show");
    restoreScroll();
  }, 0);
};
